import { Component, Inject, AfterViewInit, ViewChild, ChangeDetectorRef, ElementRef} from '@angular/core';/*, Pipe, PipeTransform*/
import { LabService } from "../service/lab.service";
import { LabDataModel, UserData, LabInstructionModel, keyvaluepair, LabViewModel, LabResults, UrineCultureGrowth } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { ModalComponent } from "../../shared/modeldialog/index";
import { SecurityService } from '../../Security/security.service';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { Router } from "@angular/router";
import { FileToUpload } from "../../Model/Documents/FileToUpload";
import { DomSanitizer, SafeResourceUrl  } from '@angular/platform-browser';
import { jsPDF } from "jspdf";
//import * as pdfMake from 'pdfmake/build/pdfmake';
//import * as pdfFonts from 'pdfmake/build/vfs_fonts';
//pdfMake.vfs = pdfFonts.pdfMake.vfs;
//import htmlToPdfmake from 'html-to-pdfmake';


declare let jspdf: any;
declare let html2canvas: any;
declare var labGrid: any;
declare var require: any;


@Component({
    selector: 'MentisSoft-Lab',
    template: require('../Template/Lab.template.html'),
    styles: [require('../Template/Lab.css')]
})

export class LabComponent implements AfterViewInit {
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    @ViewChild("labreportPopup") labreportPopup: ModalComponent;
    @ViewChild("viewInstructionsModel") viewInstructionsModel: ModalComponent;
	@ViewChild("viewCultureGrowth") viewCultureGrowth: ModalComponent;	
    @ViewChild("OpenExternal") openExternal: ModalComponent;
    @ViewChild("MicroReport") MicroReport: ModalComponent;
    @ViewChild("loadingindicator") loadingindicator: ModalComponent;
	 @ViewChild("viewReportsModel") viewReportsModel: ModalComponent;
    //@ViewChild('Html2Pdf1') pdfTable: ElementRef;
    urlSafe: SafeResourceUrl;

    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private _labService: LabService, private _titleService: Title, private cdr: ChangeDetectorRef,
        private router: Router, public sanitizer: DomSanitizer) {
        labGrid = this;
        
    }
  Report: any;
    doctorList: string[] = [];
    status: string[] = [];
    Date: string[] = [];
    testList: string[] = [];
    loading = false;
    Status: string;
    dataSource: LabDataModel[] = [];
    LabFilter: LabDataModel = new LabDataModel();
    labResult: LabResults[] = [];
	CultureGrowth : UrineCultureGrowth[] = [];
    columns: any[] = [];
    labInstructions: LabInstructionModel = new LabInstructionModel();
    Instructions: string;
	InstructionData : string;
    bFiltersLoaded: boolean = false;
    count: number;
	enableGrowth : boolean = false;
    filePath: string;
    requestDate: string;
    doctorName: string;
    pid: any;
    isfilePath: boolean = false;
    MicroPatientId: string = "";
    MicroDoctorName: string = "";
    MicroRequestDate: string = "";
    MicroRequestNo: string = "";
    MicroPatientName: string = "";
    MicrLabReportDetails: any = {};
    MicrLabCultureReport: any = {};
    MicroCultureReport: string = "";
    MicroOrganism: string = "";
    MicroTestName: string = "";
    MicroCPRNO: string = "";
    HospitalName: string = "";
    IsHospital: boolean = false;
    ngAfterViewInit(): void {
        $('#overlay').hide();
        this._titleService.setTitle("Lab Reports");
        this.HospitalName = localStorage.getItem("HospitalName");
        if (this.HospitalName == "IBN")  // || this.HospitalName == "HADI"
            this.IsHospital = true;
        else
            this.IsHospital = false;
        this.LoadLabReports();
    }

    onChange(event) {
        this.LoadFilterReports();
    }

      labResultPdf(): void {
      const div = document.getElementById("Html2Pdf1");
      const options = { height: div.clientHeight, width: div.clientWidth };
      html2canvas(div, options).then((canvas) => {
          const doc = new jspdf.jsPDF("p", "mm", "a4");
          var imgData = canvas.toDataURL('image/JPEG');
          /*Here are the numbers (paper width and height) that I found to work. It still creates a little overlap part between the pages, but good enough for me.if you can find an official number from jsPDF, use them. */
          var imgWidth = 210;
          var pageHeight = 295;
          var imgHeight = canvas.height * imgWidth / canvas.width;
          var heightLeft = imgHeight;
          var position = 0;

          doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              doc.addPage();
              doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;
          }
          const fileName = "labReport.pdf";
          doc.save(fileName);

      });

    }

    labResultPdf123(): void {
        const doc = new jsPDF('p', 'pt', 'a4');
        var downname = 'labReport_' + new Date().getDate() + new Date().getMonth() + new Date().getFullYear() + new Date().getHours() + new Date().getMinutes() + new Date().getMilliseconds() + '.pdf';
        doc.html(document.getElementById("Html2Pdf1"), {
            callback: function (doc) {
                doc.save(downname);
            }
        })
    }


    public buildGrid(data) {
        try {
            this.buildColumn();

            var dgrid = jQuery("#grdLabResults").data("kendoGrid");
            if (dgrid) {
                $('#grdLabResults').data().kendoGrid.destroy();
                $('#grdLabResults').empty();
            }
            jQuery('#grdLabResults').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,
               
                columns: this.columns,
                filterMenuInit: function (e) {
                    if (e.field != "SubmissionID" && e.field != "NameInsuredOrTreatyTitle") {
                        var filterMultiCheck = e.sender.thead.find("[data-field=" + e.field + "]").data("kendoFilterMultiCheck");
                        filterMultiCheck.container.empty();
                        var chkSourceData = filterMultiCheck.checkSource.data();

                        chkSourceData.sort(function (a: any, b: any) {
                            var sortStatus = 0;

                            if (a[e.field].toLowerCase() < b[e.field].toLowerCase()) {
                                sortStatus = -1;
                            } else if (a[e.field].toLowerCase() > b[e.field].toLowerCase()) {
                                sortStatus = 1;
                            }

                            return sortStatus;
                        });

                        filterMultiCheck.checkSource.data(chkSourceData.toJSON());
                        filterMultiCheck.createCheckBoxes();
                    }
                },
               
                dataBinding: this.databinding,
              
                dataSource: {
                    data: data,
                    pageSize: this.dataSource != null ? 10 : 0,
                    sort: [{
                        field: "ProfitCenter",
                        dir: "asc"
                    }, {
                        field: "Department",
                        dir: "asc"
                    }, {
                        field: "Modified",
                        dir: "desc"
                    }],
                },
            });
            jQuery("#grdLabResults").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdLabResults").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            this.handleError(ex);
        }
    }

    buildColumn(): void {
       
        this.columns = [
            {
                field: "DoctorName",
                title: "",
                template: kendo.template("#=this.buildLabReportRow(RequestDate,LabsSubData,DoctorName,Result_Available)#").bind(this)
            }
        ];
    }

    private handleError(error: any) {
       
    }

    buildLabReportRow(RequestDate: string, LabSubsData: LabViewModel[], DoctorName: string): string {
        this.requestDate = RequestDate;
        this.doctorName = DoctorName;
        var instruction: string, ReqNo: string, TestCode: string, EXTERNALFILENAME: string, EXTERNALFILEPATH: string,REPORT_NO: string;
        var row1 = "";
        var line1 = "<div class='resultstablewrap'> <div class='visit_wrap' > <div class='doctor_date'><span class='dateG'> <i class='fa fa-calendar-check-o' aria- hidden='true' > </i>" + RequestDate + " </span>";
        var line2 = " <span class='pull-right' > <strong>Dr.</strong>" + DoctorName + "</span ></div> ";
        var line3 = "</div > </div>";

        if (LabSubsData && LabSubsData.length > 0) {
            var row;

            for (var i = 0; i < LabSubsData.length; i++) {
                instruction = LabSubsData[i].Instructions;
                ReqNo = LabSubsData[i].ReqNo;
                TestCode = LabSubsData[i].TestCode;
				REPORT_NO = LabSubsData[i].REPORT_NO;
                EXTERNALFILENAME = LabSubsData[i].EXTERNAL_FILE_NAME;
                if (LabSubsData[i].ExternalFilePath != null)
                    EXTERNALFILEPATH = LabSubsData[i].ExternalFilePath;
                else
                    EXTERNALFILEPATH = ""; 
                if (LabSubsData[i].Status != "Completed" && LabSubsData[i].Status != "Pending to Collect") {
                    LabSubsData[i].Status = "Pending";
                }
                if (LabSubsData[i].ExternalFilePath != null) {
                    LabSubsData[i].Status = "Completed";
                }

               
                var r1 = "<div class='resson_visit' > <span>" + LabSubsData[i].TestName + "</span > ";
                var r2 = "<span class='pull-right' > <span class='confirm-txt' > <i class='' aria- hidden='true' > </i>  " + LabSubsData[i].Status + " </span>";               
                var r3 = "<span class='pull-right' >  <span class='confirm-txt waiting-txt'> <i class='' aria-hidden='true'> </i> " + LabSubsData[i].Status + " </span>";
                var r4 = "<a class='small_btn ml5 edit_btn view_instructbtn' onclick= labGrid.ViewInstructions('" + instruction + "') > <i class='fa fa-info-circle' aria- hidden='true' > </i> Instruction</a> ";
                var r5 = "<a class='small_btn def_btn view_resultbtn' onclick=labGrid.ViewResults('" + ReqNo + "','" + TestCode + "','"+ REPORT_NO + "','" + EXTERNALFILEPATH + "')> <i class='fa fa-file-text' aria- hidden='true' > </i > Results </a>  </span > </div>";
                //var r8 = "<a class='small_btn def_btn view_resultbtn' onclick=labGrid.ExternalResults('" + ReqNo + "','" + EXTERNALFILENAME + "')> <i class='fa fa-file-text' aria- hidden='true' > </i > External Results </a> </span > </div> ";
                var r8 = "<a class='small_btn def_btn view_resultbtn' target='_blank' href=" + EXTERNALFILEPATH + " download> <i class='fa fa-file-text' aria- hidden='true' > </i > Results </a> </span > </div> ";
                var r6 = "<a class='small_btn ml5 edit_btn disableBtn view_instructbtn' > <i class='fa fa-info-circle' aria- hidden='true' > </i>  Instruction</a> ";
                var r7 = "<a class='small_btn def_btn disableBtn  view_resultbtn'>  <i class='fa fa-file-text' aria- hidden='true' > </i >  Results </a> </span > </div> ";
                //var r9 = "<a class='small_btn def_btn disableBtn  view_resultbtn'>  <i class='fa fa-file-text' aria- hidden='true' > </i >  External Results </a> </span > </div> ";
                if (LabSubsData[i].Status == "Completed" || LabSubsData[i].Status == "Verified") {
                    row = r1 + r2;
                    row1 = row1.concat(row);
                }
                else {
                    row = r1 + r3;
                    row1 = row1.concat(row);
                }
                row = '';
                if (instruction != null) {
                    row = r4;
                    row1 = row1.concat(row);
                }
                else {
                    row = r6;
                    row1 = row1.concat(row);
                }
                row = '';
                if (LabSubsData[i].Result_Available != "0" || LabSubsData[i].EXTERNAL_FILE_NAME != null) {
                    if (LabSubsData[i].Result_Available == "0") {
                        row = r8;
                        row1 = row1.concat(row);
                    }
                    else {
                        row = r5;
                        row1 = row1.concat(row);
                    }
                }
                else {
                    row = r7;
                    row1 = row1.concat(row);
                }
                //row = '';
                //if (LabSubsData[i].EXTERNAL_FILE_NAME != null) {
                //    row = r8;
                //    row1 = row1.concat(row);
                //}
                //else {
                //    row = r9;
                //    row1 = row1.concat(row);
                //}
            }
        }
        return line1 + line2 + row1 + line3;
    }

    LoadLabInstructions(instruction) {
       for(var i = 0; i < this.dataSource.length; i++) {	   
			for(var j = 0; j < this.dataSource[i].LabsSubData.length; j++) {
				if(this.dataSource[i].LabsSubData[j].Instructions == instruction) {
                    this.InstructionData = this.dataSource[i].LabsSubData[j].Instructions_Available;
                   
					this.viewInstructionsModel.open();
				}
		    }	   	   
	    }
    }

    LoadLabResults(reqno, testcode) {
        this.loading = true;
        this.loadingindicator.open();
        this.labResult = [];
        var userInfo: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        
        userInfo.TestCode = testcode;
        userInfo.ReqNo = reqno;
        userInfo.pid = this._SecurityService.pid;
        this._labService.getLabResults(userInfo)
            .subscribe(
            p => {
                if (p != null && p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                    this._SecurityService.errorMessage = "";
                    this.loading = false;
                    
                    this.labResult = p.LabResults;
                    this.MicrLabReportDetails = p.LabResults;
                    if (this.labResult.length > 0) {
                        this.MicroDoctorName = p.LabResults[0].DoctorName;
                        this.MicroPatientId = p.LabResults[0].PatientID;
                        this.MicroPatientName = p.LabResults[0].PatientName;
                        this.MicroRequestDate = p.LabResults[0].RequestDate;
                        this.MicroCPRNO = p.LabResults[0].CPRNO;
                        this.MicroTestName = p.LabResults[0].TestName;
                        this.MicroRequestNo = reqno;
                        for (var i = 0; i < this.labResult.length; i++) { if (this.labResult[i].RefRange == "0" && this.HospitalName == "IBN") { this.labResult[i].RefRange = ""} }
                        
                        for (var i = 0; i < p.LabResults.length; i++) {                           
							if(p.LabResults[i].Growth_Flag == "Y") {
								this.CultureGrowth = p.CultureGrowth;
                                for (var i = 0; i < p.CultureGrowth.length; i++) {
                                    this.MicroCultureReport = p.CultureGrowth[0].CultureReport;
                                    this.MicroOrganism = p.CultureGrowth[0].OrganismName;
                                    if (p.CultureGrowth[i].ResistantFlag == "Intermediate") {
                                        p.CultureGrowth[i].Intermediate = "(I)";
                                    }
                                    if (p.CultureGrowth[i].ResistantFlag == "Resistant") {
                                        p.CultureGrowth[i].Resistant = "(R)";
                                    }
                                    if (p.CultureGrowth[i].ResistantFlag == "Sensitive") {
                                        p.CultureGrowth[i].Sensitive = "(S)";
                                    }
                                }
                                this.MicrLabCultureReport = p.CultureGrowth; 
                                this.MicrLabCultureReport = p.CultureGrowth.reduce((r,{OrganismName})=>{
                                   if(!r.some(o=>o.OrganismName==OrganismName)){
                                    r.push({OrganismName,groupItem:p.CultureGrowth.filter(v=>v.OrganismName==OrganismName)});
                                   }
                                 return r;
                                },[]);
    


                                this.enableGrowth = true;
                                this.cdr.detectChanges();
                                //this.resultsbuildGrid();
                               // this.viewModelPopup.open('lg');
                                this.MicroReport.open('lg');
							}
							else {
								this.enableGrowth = false;
                                this.cdr.detectChanges();
                                this.labreportPopup.open('lg');
							}
						}
                        window.document.getElementById("closeBtn").click();
                        
                    }
                    else {
                        if (this.isfilePath == true) {
                            window.open(this.filePath, '_blank');
                        }
                        window.document.getElementById("closeBtn").click();
                        console.log("data not recieved");
                    }
                }

                else if (!p.sessionExpiry || p.SessionTimeout == "Session Expired") {
                    window.document.getElementById("closeBtn").click();
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]); 
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            });
        this.loading = false;
    }

    getDistinctDoctors() {
        this.doctorList = [];
        this.doctorList.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.doctorList.indexOf(this.dataSource[i].DoctorName) == -1) {
                    this.doctorList.push(this.dataSource[i].DoctorName);
                }
            }
        }
    }
    getDistinctTestName() {
        this.testList.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                for (var j = 0; j < this.dataSource[i].LabsSubData.length; j++) {
                    if (this.testList.indexOf(this.dataSource[i].LabsSubData[j].TestName) == -1) {
                        this.testList.push(this.dataSource[i].LabsSubData[j].TestName);
                    }
                }
            }
        }
    }

    getDistinctStatus() {
        this.status.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                for (var j = 0; j < this.dataSource[i].LabsSubData.length; j++) {
                    if (this.status.indexOf(this.dataSource[i].LabsSubData[j].Status) == -1) {
                        this.status.push(this.dataSource[i].LabsSubData[j].Status);
                    }
                }
            }
        }
    }
    getDistinctDates() {
        this.Date.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.Date.indexOf(this.dataSource[i].RequestDate) == -1) {
                    this.Date.push(this.dataSource[i].RequestDate);
                }
            }
        }
    }

    buildFilters() {
        this.getDistinctDoctors();
        this.getDistinctTestName();
        this.getDistinctStatus();
        this.getDistinctDates();
    }
    LoadLabReports() {
        this.loading = true;
        var userInfo: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this.pid = this._SecurityService.pid;
        this._labService.getLabReports(userInfo)
            .subscribe(
            p => {
                if (p != null && p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                    this.loading = false;
                    this.dataSource = p.LabReports;
                   

                    if (!this.bFiltersLoaded) {
                        this.buildFilters();
                    }
                    this.bFiltersLoaded = true;

                    this.buildGrid(this.dataSource);
                    
                    this._SecurityService.errorMessage = "";
                }

                else if(!p.sessionExpiry || p.SessionTimeout == "Session Expired") {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            });
    }

    ViewInstructions(instruction) {
        this.LoadLabInstructions(instruction);
    }
    ViewResults(reqno, testcode,REPORT_NO, ExternalPath) {
        this.isfilePath = false;
        if (ExternalPath != "" && ExternalPath != null && ExternalPath != undefined) {
            this.filePath = ExternalPath;
            this.isfilePath = true;
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.filePath);
            // window.open(this.filePath,'_blank');

        } else {
            //this.openExternal.open();
        }
		if(REPORT_NO.length != 0 && REPORT_NO != null)
		{
		this.LoadRadiologyreports(REPORT_NO);
		}
		else{
        this.LoadLabResults(reqno, testcode);
		}
    }

	LoadRadiologyreports(REPORT_NO) {
        for (var i = 0; i < this.dataSource.length; i++) {
            for (var j = 0; j < this.dataSource[i].LabsSubData.length; j++) {
                if (this.dataSource[i].LabsSubData[j].REPORT_NO == REPORT_NO) {
                    this.Report = this.dataSource[i].LabsSubData[j].strRadiologyTestReport;
                    this.viewReportsModel.open();
                }
            }
        }		
    }
    ExternalResults(reqno, EXTERNALFILENAME) {
       
        var userInfo: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        let file = new FileToUpload();

       
        file.PatientId = this._SecurityService.pid;
        file.fileName = EXTERNALFILENAME;
        file.FolderType = "TestResults";
       
        userInfo.pid = this._SecurityService.pid;
        this._labService.getExternalResults(file, userInfo)
            .subscribe(
                p => {
                    if (p != null && p.SessionTimeout != "Session Expired") {
                        this._SecurityService.errorMessage = "";
                        if (p.FilePath != "" && p.FilePath != null && p.FilePath != undefined) {
                            this.filePath = p.FilePath;
                            window.open(this.filePath, "_blank");

                        } else {
                            this.openExternal.open();
                        }
                    }

                    else if ( p.SessionTimeout == "Session Expired") {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while validating...");
                });
    }

    
    databinding(e: any) {
        try {
            var grid = jQuery("#grdLabResults").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            this.count = totalCount;
            var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {
           
        }
    }

    getFilteredData(ds: LabDataModel[], filter: keyvaluepair): LabDataModel[] {
        let count;
        let dsFiltered: LabDataModel[] = [];
        let dssubdata: LabViewModel = new LabViewModel();
        if (filter != null && ds != null && ds.length > 0) {
            for (let d in ds) {
                count = 0;
                if (filter.key == "TestName" || filter.key == "Status") {
                    for (var d1 in ds[d].LabsSubData) {
                        for (var d2 in ds[d].LabsSubData[d1]) {
                            if (filter.key == d2) {
                                if (filter.value == ds[d].LabsSubData[d1][d2]) {
                                    count++;
                                    dssubdata = ds[d].LabsSubData[d1];
                                    if (count < 2) {
                                        dsFiltered.push(ds[d]);
                                    }

                                    
                                }
                            }
                        }
                    }
                }
                else {
                    for (var d1 in ds[d]) {
                        if (filter.key == d1) {
                            if (filter.value == ds[d][d1]) {
                                dsFiltered.push(ds[d]);
                            }
                        }
                    }
                }
            }
        }
        return dsFiltered;
    }

    getFilteredDataSource(filter: keyvaluepair[]): LabDataModel[] {
        let ds: LabDataModel[] = this.dataSource;
        if (filter != null && filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                ds = this.getFilteredData(ds, filter[i]);
            }
        }
        return ds;
    }

    LoadFilterReports() {
        if (this.dataSource != null) {
            let labFilters: keyvaluepair[] = [];

            for (var f in this.LabFilter) {
                if (this.LabFilter[f] != undefined && this.LabFilter[f] != null && this.LabFilter[f] != 'All') {
                    let kv: keyvaluepair = new keyvaluepair();
                    kv.key = f;
                    kv.value = this.LabFilter[f];
                    labFilters.push(kv);
                }
            }

            this.buildGrid(this.getFilteredDataSource(labFilters));
        }
    }

    public resultsbuildGrid() {
        try {
            this.resultbuildColumn();

            var dgrid = jQuery("#grdViewReport").data("kendoGrid");
            if (dgrid) {
                $('#grdViewReport').data().kendoGrid.destroy();
                $('#grdViewReport').empty();
            }
            jQuery('#grdViewReport').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,
               
                columns: this.columns,

                
                dataBinding: this.Resultsdatabinding,
                
                dataSource: {
                    data: this.labResult,
                    
                    pageSize: this.labResult != null ? 10 : 0,
                },
            });
            jQuery("#grdViewReport").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdViewReport").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            this.handleError(ex);
        }
    }

    resultbuildColumn(): void {
       
        this.columns = [
            {
                field: "ResultName",
                title: "Result Name",
            },
            {
                field: "ObservedValue",
                title: "Observed Value",
            },
            {
                field: "RefRange",
                title: "RefRange",
            },
            {
                field: "AbnormalFlag",
                title: "Flag",
                template: kendo.template("#=this.buildLabRow(AbnormalFlag)#").bind(this)
            },
            {
                field: "Units",
                title: "Units",  									
            }
        ];
    }

	buildLabRow(AbnormalFlag : string) : string {
		if(AbnormalFlag == "ABNORMAL") {
			return "<div style='color:red'>"+ AbnormalFlag +"</div>";
		}		
		else {
			return "<div>"+ AbnormalFlag +"</div>";
		}
	}

    Resultsdatabinding(e: any) {
        try {
            var grid = jQuery("#grdAllergyResults").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {
          
        }
    }


	 public GrowthresultsGrid() {
        try {
            this.GrowthbuildColumn();

            var dgrid = jQuery("#grdViewCultureGrowth").data("kendoGrid");
            if (dgrid) {
                $('#grdViewCultureGrowth').data().kendoGrid.destroy();
                $('#grdViewCultureGrowth').empty();
            }
            jQuery('#grdViewCultureGrowth').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,
               
                columns: this.columns,

                
                dataBinding: this.Growthdatabinding,
             
                dataSource: {
                    data: this.CultureGrowth,
                   
                    pageSize: this.labResult != null ? 10 : 0,
                },
            });
            jQuery("#grdViewCultureGrowth").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdViewCultureGrowth").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            this.handleError(ex);
        }
    }

    GrowthbuildColumn(): void {
        
        this.columns = [
            {
                field: "OrganismName",
                title: "Organism Name",
            },
            {
                field: "AntibioticName",
                title: "Antibiotic Name",
            },
            {
                field: "ResistantFlag",
                title: "Resistant Flag",
            },
			{
                field: "GrowthOption",
                title: "Growth Option",
            },
            {
                field: "CultureReport",
                title: "Culture Report",
            }, 
        ];
    }

    Growthdatabinding(e: any) {
        try {
            var grid = jQuery("#grdViewCultureGrowth").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {
           
        }
    }

	ViewCultureGrowth() {
		this.GrowthresultsGrid();		
		this.viewCultureGrowth.open('lg');
    }
    ExternalClose() {
        this.openExternal.close();
        this.isfilePath = false;
    }

    makeMicroPdf() {
        const doc = new jsPDF('p', 'pt', 'a4');
        var downname = 'labReport_' + new Date().getDate() + new Date().getMonth() + new Date().getFullYear() + new Date().getHours() + new Date().getMinutes() + new Date().getMilliseconds() + '.pdf';
        doc.html(document.getElementById("Html2Pdf"), {
            callback: function (doc) {
                doc.save(downname);
            }
        })
        //const div = document.getElementById("Html2Pdf");
        //const options = { height: div.clientHeight, width: div.clientWidth };
        //html2canvas(div, options).then((canvas) => {

        //    const doc = new jspdf.jsPDF("p", "mm", "a4");

        //    const imgData = canvas.toDataURL("image/JPEG");

        //    doc.addImage(imgData, 'JPEG', 30, 30);

        //    const fileName = "MicroLab.pdf";

        //    doc.save(fileName);
        //});
    }

    //public downloadAsPDF() {
    //    const pdfTable = this.pdfTable.nativeElement;
    //    var html = htmlToPdfmake(pdfTable.outerHTML);
    //    const documentDefinition = { content: html };
    //    pdfMake.createPdf(documentDefinition).download("LabReport.pdf");
    //}
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/lab/Component/Lab.Component.ts